import { TICKERS } from "@/mocks/home";

const STATS = [
  { value: "820万+", label: "注册瓜友" },
  { value: "36万+", label: "开播主播" },
  { value: "1.2亿+", label: "累计弹幕" },
  { value: "24h", label: "全天候在线" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      {/* background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=vibrant%20warm%20toned%20live%20streaming%20gossip%20talk%20stage%20at%20night%20with%20coral%20and%20tangerine%20spotlights%20and%20amber%20bokeh%2C%20energetic%20crowd%20silhouettes%20watching%20a%20huge%20screen%20full%20of%20scrolling%20danmaku%20comments%2C%20cinematic%20dramatic%20warm%20glow%2C%20immersive%20entertainment%20show%20atmosphere%2C%20high%20contrast%20text%20readability%2C%20rich%20orange%20and%20honey%20color%20palette&width=1600&height=900&seq=hero-ckks-main&orientation=landscape"
          alt="吃瓜快手直播互动现场，暖色舞台灯光下弹幕刷屏的热闹氛围"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>
      </div>

      <div className="relative mx-auto flex min-h-[92vh] w-full max-w-7xl flex-col justify-center px-4 md:px-8 pt-24 pb-14">
        <div className="mx-auto w-full max-w-4xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-sm font-medium text-background-50 backdrop-blur">
            <span className="live-dot inline-block h-2 w-2 rounded-full bg-red-500"></span>
            <span>正在热播中 · 实时在线围观</span>
          </span>

          <h2 className="mt-6 text-4xl md:text-6xl font-black leading-tight tracking-tight text-background-50">
            在线吃瓜
            <span className="font-accent-latin mx-3 text-primary-500 align-middle text-4xl md:text-5xl">LIVE</span>
            <br className="hidden md:block" />
            来晚就只能看回放
          </h2>

          <p className="mx-auto mt-6 max-w-2xl text-base md:text-lg leading-8 text-background-100">
            连麦、打赏、弹幕、礼物、回放一应俱全。实时参与吃瓜现场，与主播和网友零距离互动，体验最热闹的直播吃瓜氛围。
          </p>

          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#live"
              className="inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-full bg-primary-500 px-8 py-4 text-base font-bold text-foreground-950 transition hover:bg-primary-600 whitespace-nowrap"
            >
              <i className="ri-vidicon-fill text-lg" />
              进入直播现场
            </a>
            <a
              href="#rank"
              className="inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-8 py-4 text-base font-semibold text-background-50 backdrop-blur transition hover:bg-background-50/20 whitespace-nowrap"
            >
              <i className="ri-play-list-2-line text-lg" />
              看看吃瓜热榜
            </a>
          </div>

          <div className="mx-auto mt-12 grid max-w-2xl grid-cols-2 gap-3 sm:grid-cols-4">
            {STATS.map((s) => (
              <div key={s.label} className="rounded-2xl border border-background-50/15 bg-background-50/10 px-3 py-4 backdrop-blur">
                <p className="text-xl md:text-2xl font-bold text-background-50">{s.value}</p>
                <p className="mt-1 text-xs text-background-100/80">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ticker strip */}
      <div className="relative z-10 bg-primary-500 py-3 text-foreground-950">
        <div className="flex w-full overflow-hidden">
          <div className="ticker-track flex shrink-0 items-center gap-12 pr-12 whitespace-nowrap">
            {[...TICKERS, ...TICKERS].map((t, i) => (
              <span key={i} className="inline-flex items-center gap-2 text-sm font-medium">
                <i className="ri-focus-3-fill text-foreground-800" />
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}